module.exports = __webpack_public_path__ + "img/satori komeiji_sc1.eb21a7ea.png";